
<template>
  <div>
    <!--新建-->
    <a-modal
      title="操作"
      style="top: 20px"
      :width="1000"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :maskClosable="false"
    >
      <div v-if="train == 1">
        <a-form :form="form">
          <a-row>
            <a-col :span="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌型号" style="width: 410px">
                <a-input-search style="margin-bottom: 8px" @search="onSearch2" v-model="collectSearch2" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <a-tree
          checkable
          @expand="onExpand"
          :expandedKeys="expandedKeys2"
          :autoExpandParent="autoExpandParent"
          v-model="checkedKeys"
          @change="onChange22"
          @select="onSelect"
          :selectedKeys="selectedKeys"
          :treeData="configure"
        />
      </div>
    </a-modal>

    <a-modal
      title="操作"
      style="top: 20px"
      :width="1000"
      v-model="visible2"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit2"
      :footer="null"
      :maskClosable="false"
    >
      <a-form :form="form1">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌">
              <a-select
                disabled="disabled"
                v-model="brandList"
                mode="tags"
                :size="size"
                style="width: 200px"
                @change="onChange2"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号">
              <a-select
                disabled="disabled"
                v-model="modelList"
                mode="tags"
                :size="size"
                style="width: 200px"
                @change="onChange2"
              >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <div>
          <a-radio-group v-model="value" @change="onChangeRadio">
            <a-radio-button value="0"> 注意事项 </a-radio-button>
            <a-radio-button value="1"> 视频 </a-radio-button>
            <a-radio-button value="2"> 全部资料 </a-radio-button>
          </a-radio-group>
        </div>
        <div v-if="value == 0">
          <a-row :gutter="24" style="margin: 20px 0">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :class="status == 1 ? 'disEvents' : ''">
              <a-col :span="5">
                <a-checkbox @change="onChange9" v-model="checkboxText" :disabled="TextLength == 0">
                  强制提醒:
                </a-checkbox>
              </a-col>
              <a-col :span="12">
                <a-input
                  @change="ReminderChange"
                  v-model="forceReminderText"
                  :disabled="checkboxText == true"
                  :class="status == 1 ? 'disEvents' : ''"
                />
              </a-col>
            </a-form-item>
          </a-row>
          <a-button
            @click="relevance"
            type="primary"
            style="margin-bottom: 10px"
            :class="status == 1 ? 'disEvents' : ''"
            >新增</a-button
          >
          <a-button
            @click="sortFlagClick"
            v-if="sortFlag"
            type="primary"
            style="margin-bottom: 10px; margin-left: 20px"
            :class="status == 1 ? 'disEvents' : ''"
            >排序</a-button
          >
          <a-button v-if="!sortFlag" @click="SubSortClick" type="primary" style="margin-bottom: 10px; margin-left: 20px"
            >确定</a-button
          >
          <a-button v-if="!sortFlag" @click="UnsortFlagClick" style="margin-bottom: 10px; margin-left: 20px"
            >取消</a-button
          >
          <a-table size="default" ref="table" rowKey="accessoryId" :columns="columns3" :dataSource="trainingList">
            <span slot="action2" slot-scope="text, record">
              <a-button @click="sortAdd(record)">上移</a-button>
              <a-button style="margin-left: 8px" @click="sortBoom(record)">下移</a-button>
            </span>
            <span slot="action" slot-scope="text, record">
              <a style="line-height: 30px" @click="comment(record)"
                ><img src="/images/collection.png" style="width: 18px; height: 18px" />
                {{ record.commentNum.comment }}</a
              >
              <a-divider type="vertical" />
              <a style="line-height: 30px" @click="comment2(record)"
                ><img src="/images/commentNum.png" style="width: 18px; height: 18px" />
                {{ record.collection.collection }}</a
              >
              <a-divider type="vertical" />
              <a style="line-height: 30px" @click="comment3(record)"
                ><img src="/images/giveTheThumbsUp.png" style="width: 18px; height: 18px" />
                {{ record.giveTheThumbsUp.giveTheThumbsUp }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment4(record)" style="line-height: 30px"
                ><img src="/images/stepLower.png" style="width: 18px; height: 18px" />
                {{ record.stepLower.stepLower }}</a
              >
              <a-divider type="vertical" />
              <a style="line-height: 30px" @click="comment8(record)">查看</a>
              <a-divider type="vertical" />
              <a style="line-height: 30px" @click="comment7(record)" :class="status == 1 ? 'disEvents' : ''">编辑</a>
              <a-divider type="vertical" />
              <a
                @click="comment6(record)"
                style="line-height: 30px"
                v-if="record.isDisable == 0"
                :class="status == 1 ? 'disEvents' : ''"
                >禁用</a
              >
              <a
                @click="comment6(record)"
                style="line-height: 30px"
                v-if="record.isDisable == 1"
                :class="status == 1 ? 'disEvents' : ''"
                >启用</a
              >
              <a-divider type="vertical" />
              <a style="line-height: 30px" @click="comment5(record)" :class="status == 1 ? 'disEvents' : ''">删除</a>
            </span>
          </a-table>
        </div>
        <div v-if="value == 1">
          <div>
            <a-button @click="relevance2" type="primary" style="margin: 10px 0" :class="status == 1 ? 'disEvents' : ''"
              >新增</a-button
            >
            <a-button
              @click="sortFlagClick"
              v-if="sortFlag"
              type="primary"
              style="margin-bottom: 10px; margin-left: 20px"
              :class="status == 1 ? 'disEvents' : ''"
              >排序</a-button
            >
            <a-button
              v-if="!sortFlag"
              @click="SubSortClick"
              type="primary"
              style="margin-bottom: 10px; margin-left: 20px"
              >确定</a-button
            >
            <a-button v-if="!sortFlag" @click="UnsortFlagClick" style="margin-bottom: 10px; margin-left: 20px"
              >取消</a-button
            >
          </div>
          <a-table size="default" ref="table" :columns="columns4" :dataSource="trainingList">
            <span slot="action2" slot-scope="text, record">
              <a-button @click="sortAdd(record)">上移</a-button>
              <a-button style="margin-left: 8px" @click="sortBoom(record)">下移</a-button>
            </span>
            <span slot="matterUrl" slot-scope="text, record">
              <video
                class="video"
                :src="process + '/dfs/download?fileName=' + record.matterUrl + '&token=' + headers.token"
                controls
              ></video>
            </span>
            <span slot="action" slot-scope="text, record">
              <a style="" @click="comment(record)"
                ><img src="/images/collection.png" style="width: 18px; height: 18px" />
                {{ record.collection.collection }}</a
              >
              <a-divider type="vertical" /><a @click="comment2(record)">
                <img src="/images/commentNum.png" style="width: 18px; height: 18px" />
                {{ record.commentNum.comment }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment3(record)">
                <img src="/images/giveTheThumbsUp.png" style="width: 18px; height: 18px" />
                {{ record.giveTheThumbsUp.giveTheThumbsUp }}
              </a>
              <a-divider type="vertical" />
              <a @click="comment4(record)"
                ><img src="/images/stepLower.png" style="width: 18px; height: 18px" />
                {{ record.stepLower.stepLower }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment88(record)">查看</a>
              <a-divider type="vertical" />
              <a @click="comment77(record)" :class="status == 1 ? 'disEvents' : ''">编辑</a>
              <a-divider type="vertical" />
              <a @click="comment6(record)" v-if="record.isDisable == 0" :class="status == 1 ? 'disEvents' : ''">禁用</a>
              <a @click="comment6(record)" v-if="record.isDisable == 1" :class="status == 1 ? 'disEvents' : ''">启用</a>
              <a-divider type="vertical" />
              <a @click="comment52(record)" :class="status == 1 ? 'disEvents' : ''">删除</a>
            </span>
          </a-table>
        </div>
        <div v-if="value == 2">
          <div>
            <a-button @click="relevance3" type="primary" style="margin: 10px 0" :class="status == 1 ? 'disEvents' : ''"
              >新增</a-button
            >
            <a-button
              @click="sortFlagClick"
              v-if="sortFlag"
              type="primary"
              style="margin-bottom: 10px; margin-left: 20px"
              :class="status == 1 ? 'disEvents' : ''"
              >排序</a-button
            >
            <a-button
              v-if="!sortFlag"
              @click="SubSortClick"
              type="primary"
              style="margin-bottom: 10px; margin-left: 20px"
              >确定</a-button
            >
            <a-button v-if="!sortFlag" @click="UnsortFlagClick" style="margin-bottom: 10px; margin-left: 20px"
              >取消</a-button
            >
          </div>
          <a-table size="default" ref="table" :columns="columns5" :dataSource="trainingList">
            <span slot="action2" slot-scope="text, record">
              <a-button @click="sortAdd(record)">上移</a-button>
              <a-button style="margin-left: 8px" @click="sortBoom(record)">下移</a-button>
            </span>
            <span slot="matterUrl" slot-scope="text, record">
              <video
                v-if="matchType(record.matterUrl) == 'video'"
                class="video"
                :src="process + '/dfs/download?fileName=' + record.matterUrl + '&token=' + headers.token"
                controls
              ></video>
              <img
                v-else-if="matchType(record.matterUrl) == 'image'"
                style="width: 100px; height: 100px"
                :src="process + '/dfs/download?fileName=' + record.matterUrl + '&token=' + headers.token"
              />
              <a
                :href="process + '/dfs/download?fileName=' + record.matterUrl + '&token=' + headers.token"
                download
                v-else
                style="width: 200px"
                >{{ record.matterUrl }}</a
              >
            </span>
            <span slot="action" slot-scope="text, record">
              <a style="" @click="comment(record)"
                ><img src="/images/collection.png" style="width: 18px; height: 18px" />
                {{ record.collection.collection }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment2(record)"
                ><img src="/images/commentNum.png" style="width: 18px; height: 18px" />
                {{ record.commentNum.comment }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment3(record)"
                ><img src="/images/giveTheThumbsUp.png" style="width: 18px; height: 18px" />
                {{ record.giveTheThumbsUp.giveTheThumbsUp }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment4(record)"
                ><img src="/images/stepLower.png" style="width: 18px; height: 18px" />
                {{ record.stepLower.stepLower }}</a
              >
              <a-divider type="vertical" />
              <a @click="comment888(record)">查看</a>
              <a-divider type="vertical" />
              <a @click="comment777(record)" :class="status == 1 ? 'disEvents' : ''">编辑</a>
              <a-divider type="vertical" />
              <a @click="comment6(record)" v-if="record.isDisable == 0" :class="status == 1 ? 'disEvents' : ''">禁用</a>
              <a @click="comment6(record)" v-if="record.isDisable == 1" :class="status == 1 ? 'disEvents' : ''">启用</a>
              <a-divider type="vertical" />
              <a @click="comment522(record)" :class="status == 1 ? 'disEvents' : ''">删除</a>
            </span>
          </a-table>
        </div>
      </a-form>
    </a-modal>
    <!--评论-->
    <a-modal
      title="评论"
      style="top: 20px"
      :width="1000"
      v-model="visible3"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit3"
      :maskClosable="false"
    >
      <a-table size="default" ref="table" rowKey="accessoryId" :columns="columns" :dataSource="comments"> </a-table>
    </a-modal>

    <!--收藏-->
    <a-modal
      title="收藏"
      style="top: 20px"
      :width="1000"
      v-model="visible4"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit4"
      :maskClosable="false"
    >
      <a-table size="default" ref="table" rowKey="accessoryId" :columns="columns2" :dataSource="comments2"> </a-table>
    </a-modal>

    <!--  点赞  -->
    <a-modal
      title="点赞"
      style="top: 20px"
      :width="1000"
      v-model="visible5"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit5"
      :maskClosable="false"
    >
      <a-table size="default" ref="table" rowKey="accessoryId" :columns="columns2" :dataSource="comments2"> </a-table>
    </a-modal>

    <!--    踩-->
    <a-modal
      title="踩"
      style="top: 20px"
      :width="1000"
      v-model="visible6"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit6"
      :maskClosable="false"
    >
      <a-table size="default" ref="table" rowKey="accessoryId" :columns="columns2" :dataSource="comments2"> </a-table>
    </a-modal>

    <!-- 查看-->
    <a-modal
      title="查看"
      style="top: 20px"
      :width="1000"
      v-model="visible8"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit8"
      :maskClosable="false"
    >
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">
        <a-input v-model="see.matterTitle" :disabled="true" />
      </a-form-item>

      <!--        <span v-html="see.matterUrl">-->

      <!--        </span>-->
      <editor id="tinymce" v-model="see.matterUrl" :init="init" :disabled="true"></editor>
    </a-modal>

    <!--编辑-->
    <a-modal
      title="编辑"
      style="top: 20px"
      :width="1000"
      v-model="visible9"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit9"
      :maskClosable="false"
    >
      <a-form :form="form" :class="[enterpriseShow == 0 ? 'disEvents' : '']">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="主题">
          <a-input v-model="matterTitle2" />
        </a-form-item>

        <editor id="tinymce1" v-model="releaseScope" :init="init"></editor>
      </a-form>
    </a-modal>

    <!--上传视频-->
    <a-modal
      title="上传视频"
      style="top: 20px"
      :width="1000"
      v-model="visible10"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit10"
      :maskClosable="false"
    >
      <a-form :form="form2" :class="[enterpriseShow == 0 ? 'disEvents' : '']">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="主题">
          <a-input v-model="theme" maxlength="50" />
        </a-form-item>
        <a-upload
          :multiple="true"
          name="file"
          list-type="picture"
          class="avatar-uploader"
          :headers="headers"
          :action="uploadUrl"
          :fileList="fileList3"
          :before-upload="beforeUpload"
          @change="currencyhandleChange"
        >
          <a-button> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="说明">
          <a-input v-model="remark" maxlength="50" />
        </a-form-item>
      </a-form>
      <video
        v-if="UpInfoShow"
        style="width: 30%; height: 30%"
        :src="process + '/dfs/download?fileName=' + currencyhandleChangeSrc + '&token=' + headers.token"
        controls
      ></video>
      <!--<video src="file://D:\lockan\uploadPath\exam\2020\07\01\a3fed8f839ec574efc65d69b7cda0c25.wma" style="'width:100%" controls></video>-->
    </a-modal>

    <!--上传文件-->
    <a-modal
      title="上传文件"
      style="top: 20px"
      :width="1000"
      v-model="visible11"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit11"
      :maskClosable="false"
    >
      <a-form :form="form3" :class="[enterpriseShow == 0 ? 'disEvents' : '']">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="主题">
          <a-input v-decorator="['matterTitle', { rules: [{ required: true, message: '请输入主题内容' }] }]" />
        </a-form-item>
        <a-upload
          name="file"
          :action="uploadUrlb2"
          :headers="headers"
          :fileList="fileList4"
          @change="uploadChange"
          showUploadList="false"
        >
          <a-button style="" type="primary" ghost :disabled="isDisable1">添加</a-button>
        </a-upload>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="说明">
          <a-input v-decorator="['remark', { rules: [{ required: true, message: '请输入说明内容' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script >
import {
  selectBrand,
  updateSort,
  selectInfo,
  insertRemind,
  selectModel,
  statusInfo,
  insert2,
  list2,
  insertInfo,
  getTitle,
  selectThumbsUpList,
  selectCommentList,
  selectCollectionList,
  selectStepLowerList,
  selectCommentNum,
  selectStepLowerNum,
  selectCollectionNum,
  selectThumbsUpNum,
  getInfo,
  selectSelectionModel,
} from '@/api/trainOverview/trainOverview'
import { getDictMap } from '../../../utils/dict'
import pick from 'lodash.pick'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/icons/default'
export default {
  name: 'accessoryModal',
  props: {},
  components: {
    Editor,
  },
  data() {
    return {
      collectSearch2: '',
      // 显示品牌
      TextLength: 0,
      sortFlag: true,
      forceReminderText: '',
      enterpriseShow: 0,
      brandList: [],
      form3: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      form1: this.$form.createForm(this),
      // 显示型号
      modelList: [],
      fileList3: [],
      fileList4: [],
      UpInfoShow: false,
      // 主题
      theme: '',
      // 备注
      remark: '',
      // 上传视频地址
      uploadVideo: '',
      uploadVideo2: '',
      trainingMaterialsId: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      // 上传文件
      uploadUrlb2: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=exam',
      // 上传视频
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=exam',
      process: process.env.VUE_APP_API_BASE_URL,
      // 启禁状态
      isDisable: '',
      // 选中配置
      enterprise: '',
      // 查看
      see: '',
      // 培训详情id
      matterInfoId: '',
      // 编辑的标题
      matterTitle: [],
      trainingList: [],
      // 编辑主题
      matterTitle2: '',
      matterTitleStore: [],
      soteData: [],
      releaseScope: '',

      checked2: '',
      value: '1',
      expandedKeys2: [],
      autoExpandParent2: true,
      autoExpandParent: true,
      expandedKeys: [],
      checkedKeys: [],
      checkedKeys2: [],
      selectedKeys: [],
      selectedKeys2: [],
      // 配置
      configure: '',
      // 品牌
      brand: '',
      // 培训判断
      train: '',
      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      visible6: false,
      visible7: false,
      visible8: false,
      visible9: false,
      visible10: false,
      visible11: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns3: [
        {
          title: '主题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      columns4: [
        {
          title: '主题',
          dataIndex: 'title',
          width: '80px',
          align: 'center',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '视频',
          dataIndex: 'matterUrl',
          align: 'center',
          scopedSlots: { customRender: 'matterUrl' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      uncolumns4: [
        {
          title: '排序',
          dataIndex: 'title',
          width: '180px',
          align: 'center',
          scopedSlots: { customRender: 'action2' },
        },
        {
          title: '主题',
          dataIndex: 'title',
          width: '80px',
          align: 'center',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '视频',
          dataIndex: 'matterUrl',
          align: 'center',
          scopedSlots: { customRender: 'matterUrl' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      undatacolumns4: [
        {
          title: '主题',
          dataIndex: 'title',
          width: '80px',
          align: 'center',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '视频',
          dataIndex: 'matterUrl',
          align: 'center',
          scopedSlots: { customRender: 'matterUrl' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      uncolumns5: [
        {
          title: '排序',
          dataIndex: 'title',
          width: '180px',
          align: 'center',
          scopedSlots: { customRender: 'action2' },
        },
        {
          title: '主题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '名称',
          dataIndex: 'matterUrl',
          scopedSlots: { customRender: 'matterUrl' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      columns5: [
        {
          title: '主题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '名称',
          dataIndex: 'matterUrl',
          scopedSlots: { customRender: 'matterUrl' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      undatacolumns5: [
        {
          title: '主题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title' },
        },
        {
          title: '名称',
          dataIndex: 'matterUrl',
          scopedSlots: { customRender: 'matterUrl' },
        },
        {
          title: '操作',
          width: '220px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      columns: [
        {
          title: '师傅姓名',
          dataIndex: 'createBy',
          scopedSlots: { customRender: 'createBy' },
        },
        {
          title: '联系方式',
          dataIndex: 'phoneNumber',
          scopedSlots: { customRender: 'phoneNumber' },
        },
        {
          title: '评论内容',
          dataIndex: 'comment',
          scopedSlots: { customRender: 'comment' },
        },
        {
          title: '时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
        },
      ],
      columns2: [
        {
          title: '师傅姓名',
          dataIndex: 'createBy',
          scopedSlots: { customRender: 'createBy' },
        },
        {
          title: '联系方式',
          dataIndex: 'phoneNumber',
          scopedSlots: { customRender: 'phoneNumber' },
        },
        {
          title: '时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
        },
      ],
      // 评论数量
      commentNum: '',
      examine: 0,
      // 评论内容
      comments: [],
      // 踩 数量
      stepOnNum: '',
      // 收藏数量
      collectionNum: '',
      // 点赞 数量
      giveTheThumbsUpNum: '',
      // 收藏、点赞
      comments2: [],
      checkboxText: false,
      confirmLoading: false,
      currencyhandleChangeSrc: '',
      mdl: {},
      status: 0,
      form: this.$form.createForm(this),
      init: {
        language_url: '/tinymce/langs/zh_CN.js', //语言包的路径
        language: 'zh_CN', //语言
        skin_url: '/tinymce/skins/ui/oxide', //skin路径
        height: 300, //编辑器高度
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: false, //顶部菜单栏显示,
        images_upload_handler: (blobInfo, success, failure) => {
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        },
        video_template_callback: function (data) {},
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount media',
        ],
        toolbar:
          'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image media  code | removeformat',
      },
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {
    tinymce.init({})
  },
  methods: {
    onSearch2(e) {
      console.log(e)
      this.searchValue = e
      var vm = this
      //添加这行代码是为了只点击搜索才触发
      vm.searchValue = vm.searchStr
      //如果搜索值为空，则不展开任何项，expandedKeys置为空
      //如果搜索值不位空，则expandedKeys的值要为搜索值的父亲及其所有祖先
      if (vm.searchValue === '') {
        vm.expandedKeys2 = []
      } else {
        //首先将展开项与展开项副本置为空
        vm.expandedKeys2 = []
        vm.backupsExpandedKeys2 = []
        //获取所有存在searchValue的节点
        let candidateKeysList = vm.getkeyList(e, vm.configure, [])
        console.log(candidateKeysList)
        vm.checkedKeys = candidateKeysList
        //遍历满足条件的所有节点
        candidateKeysList.map((item) => {
          //获取每个节点的母亲节点
          var key = vm.getParentKey(item, vm.configure)
          //当item是最高一级，父key为undefined，将不放入到数组中
          //如果母亲已存在于数组中，也不放入到数组中
          if (key && !vm.backupsExpandedKeys2.some((item) => item === key)) vm.backupsExpandedKeys2.push(key)
        })
        console.log(vm.backupsExpandedKeys2)
        let length = this.backupsExpandedKeys2.length
        for (let i = 0; i < length; i++) {
          vm.getAllParentKey(vm.backupsExpandedKeys2[i], vm.configure)
        }
        vm.expandedKeys2 = vm.backupsExpandedKeys2.slice()
        console.log(vm.expandedKeys2)
      }
    },

    //获取节点中含有value的所有key集合
    getkeyList(value, tree, keyList) {
      console.log(value, tree, keyList)
      //遍历所有同一级的树
      for (let i = 0; i < tree.length; i++) {
        let node = tree[i]
        //如果该节点存在value值则push
        if (node.title.indexOf(value) > -1) {
          keyList.push(node.key)
        }
        //如果拥有孩子继续遍历
        if (node.children) {
          this.getkeyList(value, node.children, keyList)
        }
      }
      //因为是引用类型，所有每次递归操作的都是同一个数组
      return keyList
    },

    //排序上移
    sortAdd(record) {
      let str1 = ''
      for (let i = 0; i < this.trainingList.length; i++) {
        if (i > 0) {
          if (this.trainingList[i].infoId == record.infoId) {
            str1 = this.trainingList[i]
            this.trainingList.splice(i, 1)
            this.trainingList.splice(i - 1, 0, str1)
          }
        }
      }
    },
    //排序下移
    sortBoom(record) {
      console.log('下移', record, this.trainingList)
      for (var i = 0; i < this.trainingList.length - 1; i++) {
        if (this.trainingList[i].infoId == record.infoId) {
          var newjson = this.trainingList[i + 1]
          this.trainingList.splice(i, 0, newjson)
          this.trainingList.splice(i + 2, 1)
          return
        }
      }
    },
    //排序确定提交
    SubSortClick() {
      let arr = []
      for (let i = 0; i < this.trainingList.length; i++) {
        arr.push({
          sort: i + 1,
          infoId: this.trainingList[i].infoId,
        })
      }

      updateSort(arr).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.query(this.value)
        } else {
          this.query(this.value)
        }
      })

      this.sortFlag = true
      if (this.value == 0) {
        this.columns3 = [
          {
            title: '主题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title' },
          },
          {
            title: '操作',
            width: '220px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
        // this.query(this.value)
      }
    },
    //取消排序
    UnsortFlagClick() {
      this.trainingList = []
      this.sortFlag = true
      for (let i = 0; i < this.soteData.length; i++) {
        this.trainingList.push(this.soteData[i])
      }
      if (this.value == 0) {
        this.columns3 = [
          {
            title: '主题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title' },
          },
          {
            title: '操作',
            width: '220px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
      } else if (this.value == 1) {
        this.columns4 = this.undatacolumns4
      } else if (this.value == 2) {
        this.columns5 = this.undatacolumns5
      }
    },
    //排序
    sortFlagClick() {
      this.matterTitleStore = []
      for (let i = 0; i < this.trainingList.length; i++) {
        this.matterTitleStore.push(this.trainingList[i])
      }
      this.sortFlag = false
      if (this.value == 0) {
        this.columns3 = [
          {
            title: '排序',
            dataIndex: 'title',
            width: '180px',
            align: 'center',
            scopedSlots: { customRender: 'action2' },
          },
          {
            title: '主题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title' },
          },
          {
            title: '操作',
            width: '220px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
      } else if (this.value == 1) {
        this.columns4 = this.uncolumns4
      } else if (this.value == 2) {
        this.columns5 = this.uncolumns5
      }
    },
    ReminderChange(e) {
      this.TextLength = this.forceReminderText.length
      if (this.TextLength == 0) {
        this.checkboxText = false
      }
    },
    onChange9(e) {
      console.log('e', this.checkboxText)
      if (this.checkboxText) {
        if (this.forceReminderText) {
          insertRemind({
            trainingMaterialsId: this.trainingMaterialsId,
            isForceReminder: 0,
            forceReminderText: this.forceReminderText,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('强制提醒成功')
            }
          })
        } else {
          this.$message.error('强制提醒内容不能为空')
        }
      } else {
        this.forceReminderText = ''
        this.checkboxText = false
        this.TextLength = 0
        insertRemind({
          trainingMaterialsId: this.trainingMaterialsId,
          isForceReminder: 1,
          forceReminderText: this.forceReminderText,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('强制提醒已取消')
          }
        })
      }
    },
    matchType(fileName) {
      // 后缀获取
      var suffix = ''
      // 获取类型结果
      var result = ''
      try {
        var flieArr = fileName.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return result
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'image'
        return result
      }
      // 匹配txt
      var txtlist = ['txt']
      result = txtlist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'txt'
        return result
      }
      // 匹配 excel
      var excelist = ['xls', 'xlsx']
      result = excelist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'excel'
        return result
      }
      // 匹配 word
      var wordlist = ['doc', 'docx']
      result = wordlist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'word'
        return result
      }
      // 匹配 pdf
      var pdflist = ['pdf']
      result = pdflist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'pdf'
        return result
      }
      // 匹配 ppt
      var pptlist = ['ppt']
      result = pptlist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'ppt'
        return result
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'video'
        return result
      }
      // 匹配 音频
      var radiolist = ['mp3', 'wav', 'wmv']
      result = radiolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'radio'
        return result
      }
      // 其他 文件类型
      result = 'other'
      return result
    },
    //上传文件
    uploadChange(info) {
      console.log(info)
      // if(info.fileList.type  ){
      //
      // }
      this.fileList4 = info.fileList
      if (info.file.status !== 'uploading') {
        // this.$refs.table.refresh(true)
      }
      if (info.file.status === 'done') {
        this.$message.success(`上传成功`)
        this.uploadVideo2 = info.file.response.url
        if (this.fileList4.length > 1) {
          this.fileList4.shift()
        }
        // this.UpdataContract()
        // this.$refs.table.refresh(true)
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
      }
    },
    beforeUpload(file) {
      console.log(file)
    },
    // 视频上传
    currencyhandleChange(info, type) {
      console.log(info)
      if (info.file.size / 1024 / 1024 > 50) {
        this.$message.success(`超过上传限制`)
      } else {
        console.log(this.fileList3)
        this.fileList3 = info.fileList
        if (info.file.status !== 'uploading') {
          // console.log(info.file.response.fileName);
          // info.file.response
          if (info.file.response.code == 0) {
            // this.fileName=
            // infoPath.push( info.file.response.url)
            if (type == 'pic') {
              this.clientPic.push(info.file.response.url)
            }
            if (type == 'video') {
              this.clientVideo.push(info.file.response.url)
            }
            console.log(info.file)
          }
        }
        if (info.file.status === 'done') {
          console.log(info.file.response)
          this.uploadVideo = info.file.response.url
          this.$message.success(`${info.file.name}上传成功`)
          this.UpInfoShow = true
          this.currencyhandleChangeSrc = info.fileList[0].response.url
          this.fileList3 = []
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`)
        }
      }
    },
    query(value) {
      let str = {
        target: {
          value: value,
        },
      }
      this.onChangeRadio(str)
    },
    // 删除
    comment5(record) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          const TrainInfo = {
            trainType: 0,
            trainingMaterialsId: that.trainingMaterialsId,
            matterInfoId: record.infoId,
            delete: 1,
          }
          statusInfo(TrainInfo).then((res) => {
            if (res.code == 0) {
              console.log('jinru')
              that.query(0)
              that.$message.success('删除成功')
              // this.visible = false
            } else {
              that.$message.success(res.msg)
            }
          })
        },
      })
    },

    // 删除
    comment52(record) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          const TrainInfo = {
            trainType: 1,
            trainingMaterialsId: that.trainingMaterialsId,
            matterInfoId: record.infoId,
            delete: 1,
          }
          statusInfo(TrainInfo).then((res) => {
            if (res.code == 0) {
              console.log('jinru')
              that.query(1)
              that.$message.success('删除成功')
              // this.visible = false
            } else {
              that.$message.success(res.msg)
            }
          })
        },
      })
    },
    // 删除
    comment522(record) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          const TrainInfo = {
            trainType: 2,
            trainingMaterialsId: that.trainingMaterialsId,
            matterInfoId: record.infoId,
            delete: 2,
          }
          statusInfo(TrainInfo).then((res) => {
            if (res.code == 0) {
              that.query(2)
              that.$message.success('删除成功')
              // this.visible = false
            } else {
              that.$message.success(res.msg)
            }
          })
        },
      })
    },
    // 启用/禁用
    comment6(record) {
      if (record.isDisable == 0) {
        this.isDisable = 1
      } else {
        this.isDisable = 0
      }
      const TrainInfo = {
        trainType: this.value,
        trainingMaterialsId: this.trainingMaterialsId,
        matterInfoId: record.infoId,
        disable: this.isDisable,
      }
      statusInfo(TrainInfo)
        .then((res) => {
          if (res.code === 0) {
            if (this.isDisable == 1) {
              this.$message.success('禁用成功')
            } else {
              this.$message.success('启用成功')
            }
            this.query(this.value)
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    // 编辑
    comment7(record) {
      this.enterpriseShow = 1
      this.visible9 = true
      this.matterInfoId = record.infoId
      getInfo(record.infoId).then((res) => {
        if (res.code === 0) {
          this.see = res.data
          this.releaseScope = res.data.matterUrl
          this.matterTitle2 = res.data.matterTitle
          console.log(this.see)
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    // 编辑
    comment77(record) {
      this.enterpriseShow = 1
      this.examine = 1
      this.visible10 = true
      this.matterInfoId = record.infoId
      getInfo(record.infoId).then((res) => {
        console.log(res)
        if (res.code === 0) {
          this.theme = res.data.matterTitle
          this.remark = res.data.remark
          this.uploadVideo = res.data.matterUrl
          this.currencyhandleChangeSrc = res.data.matterUrl
          this.UpInfoShow = true
          // this.see =   res.data
          // this.releaseScope =  res.data.matterUrl
          //

          // this.visible = false
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    // 编辑
    comment777(record) {
      this.enterpriseShow = 1
      this.fileList4 = []
      this.visible11 = true
      this.examine = 1
      this.matterInfoId = record.infoId
      getInfo(record.infoId).then((res) => {
        console.log(res)
        if (res.code === 0) {
          this.form3.setFieldsValue({
            matterTitle: res.data.matterTitle,
            remark: res.data.remark,
          })
          this.uploadVideo2 = res.data.matterUrl
          this.fileList4.push({
            uid: res.data.matterInfoId,
            name: res.data.matterUrl,
            status: 'done',
            thumbUrl: this.process + '/dfs/download?fileName=' + res.data.matterUrl + '&token=' + this.headers.token,
          })
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    handleSubmit9() {
      if (this.matterTitle2 == '') {
        this.$message.error('请填写主题内容')
      } else if (this.releaseScope == '') {
        this.$message.error('请填写内容')
      } else {
        if (this.enterpriseShow == 1) {
          //编辑
          const TrainInfo = {
            trainType: this.value,
            trainingMaterialsId: this.trainingMaterialsId,
            matterInfoId: this.matterInfoId,
            delete: 1,
          }
          statusInfo(TrainInfo).then((res) => {
            if (res.code == 0) {
            }
          })
        }
        var matterUrl = this.releaseScope
        var trainType = 0
        const TrainInfo = {
          matterTitle: this.matterTitle2,
          matterUrl: matterUrl,
          trainType: 0,
          trainingMaterialsId: this.trainingMaterialsId,
          remark: '',
        }
        insertInfo(TrainInfo)
          .then((res) => {
            if (res.code === 0) {
              getTitle(trainType)
                .then((res) => {
                  if (res.code === 0) {
                    this.trainingList = res.rows
                    this.query(0)
                  } else {
                    this.$message.success(res.msg)
                  }
                })
                .catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
              this.visible9 = false
            } else {
              this.$message.success(res.msg)
            }
          })
          .catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
      }
    },

    // 查看确定
    handleSubmit8() {
      this.visible8 = false
    },
    // 查看
    comment8(record) {
      // this.enterpriseShow=0
      this.visible8 = true
      console.log(record)
      let matterInfoId = record.infoId
      getInfo(matterInfoId)
        .then((res) => {
          if (res.code === 0) {
            this.see = res.data
            this.see.matterUrl = this.see.matterUrl
            // .replace(/<.*?>/ig,"")
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },
    comment88(record) {
      this.comment77(record)
      this.enterpriseShow = 0
      this.examine = 0
    },
    comment888(record) {
      this.comment777(record)
      this.enterpriseShow = 0
      this.examine = 0
    },
    // 评论确定
    handleSubmit3() {
      this.visible3 = false
    },
    // 评论
    comment(record) {
      this.visible3 = true
      this.visible4 = false
      this.visible5 = false
      console.log(record)
      let matterInfoId = record.infoId

      selectCommentList({ matterInfoId: matterInfoId })
        .then((res) => {
          if (res.code === 0) {
            this.comments = res.rows
            console.log(this.comments)

            // this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    // 收藏确定
    handleSubmit4() {
      this.visible4 = false
    },
    // 收藏
    comment2(record) {
      this.visible3 = false
      this.visible4 = true
      this.visible5 = false
      console.log(record)
      let matterInfoId = record.infoId
      selectCollectionList(matterInfoId)
        .then((res) => {
          if (res.code === 0) {
            this.comments2 = res.rows
            console.log(this.comments2)

            // this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    // 点赞确定
    handleSubmit5() {
      this.visible5 = false
    },
    // 点赞
    comment3(record) {
      this.visible3 = false
      this.visible4 = false
      this.visible5 = true
      console.log(record)
      let matterInfoId = record.infoId
      selectThumbsUpList({ matterInfoId: matterInfoId })
        .then((res) => {
          if (res.code === 0) {
            this.comments2 = res.rows
            console.log(this.comments2)

            // this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    // 踩 确定
    handleSubmit6() {
      this.visible6 = false
    },
    // 踩
    comment4(record) {
      this.visible3 = false
      this.visible4 = false
      this.visible5 = false
      this.visible6 = true
      console.log(record)
      let matterInfoId = record.infoId
      selectStepLowerList({ matterInfoId: matterInfoId })
        .then((res) => {
          if (res.code === 0) {
            this.comments2 = res.rows
            console.log(this.comments2)

            // this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    // 富文本确定
    handleSubmit2() {
      if (this.matterInfoId != null) {
        var matterUrl = this.releaseScope
        if (this.value == 1) {
          var trainType = 0
          const TrainInfo = {
            matterTitle: this.matterTitle2,
            matterUrl: matterUrl,
            trainType: 0,
            trainingMaterialsId: this.matterInfoId,
            remark: '',
          }
          insertInfo(TrainInfo)
            .then((res) => {
              if (res.code === 0) {
                this.trainingList = res.rows

                // this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      } else {
        var matterUrl = this.releaseScope
        if (this.value == 1) {
          var trainType = 0
          const TrainInfo = {
            matterTitle: this.matterTitle2,
            matterUrl: matterUrl,
            trainType: 0,
            trainingMaterialsId: this.matterInfoId,
            remark: '',
          }
          insertInfo(TrainInfo)
            .then((res) => {
              if (res.code === 0) {
                this.trainingList = res.rows
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }
      }
    },

    // 新增(注意事项)
    relevance() {
      this.visible9 = true
      this.releaseScope = ''
      this.matterTitle2 = ''
      this.enterpriseShow = 2
    },

    // 新增 上传视频
    relevance2() {
      this.fileList3 = []
      this.visible10 = true
      this.examine = 1
      this.currencyhandleChangeSrc = ''
      this.UpInfoShow = false
      this.theme = ''
      this.remark = ''
      this.uploadVideo = ''
      this.enterpriseShow = 2
    },

    //  上传视频 确定
    handleSubmit10() {
      if (this.examine == 0) {
        this.visible10 = false
      } else {
        if (this.theme == '') {
          return this.$message.error('请填写主题内容')
        } else if (this.remark == '') {
          return this.$message.error('请填写说明内容')
        } else if (this.uploadVideo) {
          if (this.enterpriseShow == 1) {
            //编辑
            const TrainInfo = {
              trainType: this.value,
              trainingMaterialsId: this.trainingMaterialsId,
              matterInfoId: this.matterInfoId,
              delete: 1,
            }
            statusInfo(TrainInfo).then((res) => {
              if (res.code == 0) {
              }
            })
          }
          const TrainInfo = {
            matterTitle: this.theme,
            matterUrl: this.uploadVideo,
            trainType: 1,
            trainingMaterialsId: this.trainingMaterialsId,
            remark: this.remark,
          }
          insertInfo(TrainInfo)
            .then((res) => {
              if (res.code === 0) {
                this.visible10 = false
                this.query(this.value)
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        } else {
          this.$message.error('请上传视频')
        }
      }
    },

    //  上传文件 确定
    handleSubmit11(e) {
      e.preventDefault()
      if (this.examine == 0) {
        this.visible11 = false
      } else {
        if (this.fileList4.length != 0) {
          if (this.enterpriseShow == 1) {
            //编辑
            const TrainInfo = {
              trainType: this.value,
              trainingMaterialsId: this.trainingMaterialsId,
              matterInfoId: this.matterInfoId,
              delete: 1,
            }
            statusInfo(TrainInfo).then((res) => {
              if (res.code == 0) {
              }
            })
          }
          this.form3.validateFields((err, formValues) => {
            console.log(formValues, 'formValues')
            if (!err) {
              const TrainInfo = {
                matterTitle: formValues.matterTitle,
                matterUrl: this.uploadVideo2,
                trainType: 2,
                trainingMaterialsId: this.trainingMaterialsId,
                remark: formValues.remark,
              }
              insertInfo(TrainInfo)
                .then((res) => {
                  if (res.code === 0) {
                    this.visible11 = false
                    this.query(this.value)
                  } else {
                    this.$message.success(res.msg)
                  }
                })
                .catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
            }
          })
        } else {
          this.$message.error('请添加文件')
        }
      }
    },
    // 新增 上传文件
    relevance3() {
      this.form3.resetFields()
      this.visible11 = true
      this.examine = 1
      this.fileList4 = []
      this.uploadVideo2 = ''
      this.enterpriseShow = 2
    },

    onChangeRadio(e) {
      if (this.value == 0) {
        this.columns3 = [
          {
            title: '主题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title' },
          },
          {
            title: '操作',
            width: '220px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ]
      } else if (this.value == 1) {
        this.columns4 = this.undatacolumns4
      } else if (this.value == 2) {
        this.columns5 = this.undatacolumns5
      }
      this.sortFlag = true
      console.log(e)
      this.value = e.target.value
      console.log(`checked = ${e.target.value}`)
      const trainType = {
        trainingMaterialsId: this.trainingMaterialsId,
        trainType: this.value,
      }
      getTitle(trainType)
        .then((res) => {
          if (res.code === 0) {
            if (this.value == 0) {
              this.trainingList = res.rows
            } else {
              this.trainingList = res.rows
            }
            //取消返回数组
            this.soteData = res.rows
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },

    onSelect(selectedKeys, info) {
      console.log('onSelect', info)
      this.selectedKeys = selectedKeys
    },

    onChange22(value) {
      console.log('onChange ', value)
      this.value = value
      console.log('checked = ', checkedValues)
    },

    onExpand(expandedKeys2) {
      console.log('onExpand', expandedKeys2)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys2 = expandedKeys2
      this.autoExpandParent = true
    },

    add() {
      this.collectSearch2 = ''
      this.checkedKeys = []
      this.train = 1
      this.form.resetFields()
      this.edit({ brandId: 0 })
    },

    edit(record, status) {
      this.forceReminderText = ''
      this.value = '0'
      this.status = status
      console.log('record', record)
      selectInfo({
        trainingMaterialsId: record.trainingMaterialsId,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data.isForceReminder == 0) {
            this.checkboxText = true
          } else {
            this.checkboxText = false
            // if (this.TextLength == 0) {
            //   this.checkboxText = false
            // } else {
            //   this.checkboxText = true
            // }
          }
          this.isForceReminder = res.data.isForceReminder
          this.forceReminderText = res.data.forceReminderText
          this.TextLength = this.forceReminderText.length
        }
      })
      this.checkboxText = false
      this.form1.resetFields()
      this.trainingMaterialsId = record.trainingMaterialsId
      selectBrand(record.trainingMaterialsId)
        .then((res) => {
          if (res.code === 0) {
            console.log(this.res)
            this.brandList = res.rows
            // this.visible = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })

      selectModel(record.trainingMaterialsId)
        .then((res) => {
          if (res.code === 0) {
            this.modelList = res.rows
            console.log(res, 'selectModelselectModel')
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      if (record.trainingMaterialsId != null) {
        if (this.value == 1) {
          const trainType = {
            trainingMaterialsId: record.trainingMaterialsId,
            trainType: 0,
          }
          getTitle(trainType)
            .then((res) => {
              if (res.code === 0) {
                this.trainingList = res.rows
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        } else if (this.value == 2) {
          const trainType = {
            trainingMaterialsId: record.trainingMaterialsId,
            trainType: 1,
          }
          getTitle(trainType)
            .then((res) => {
              if (res.code === 0) {
                this.trainingList = res.rows
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        } else {
          const trainType = {
            trainingMaterialsId: record.trainingMaterialsId,
            trainType: 2,
          }
          getTitle(trainType)
            .then((res) => {
              if (res.code === 0) {
                this.trainingList = res.rows
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
        }

        this.train = 2
        console.log(record)
        this.mdl = Object.assign(record)
        this.visible2 = true
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.mdl,
              'commonFlag',
              'accessoryId',
              'accessoryName',
              'accessoryType',
              'accessoryCategory',
              'accessorySpecification',
              'delFlag',
              'forbiddenStatus',
              'createBy',
              'createTime',
              'updateBy',
              'updateTime'
            )
          )
        })
      } else {
        console.log('新建')
        var num = 0
        list2({}).then((res) => {
          console.log(res)
          if (res.code == 0) {
            selectSelectionModel().then((data) => {
              for (let i = 0; i < res.data.length; i++) {
                num = 0
                for (let k = 0; k < data.rows.length; k++) {
                  if (res.data[i].children.length != 0) {
                    for (let v = 0; v < res.data[i].children.length; v++) {
                      if (res.data[i].children[v].key == data.rows[k]) {
                        res.data[i].children[v].disableCheckbox = true
                        num++
                      }
                    }
                  }
                }
                if (num == res.data[i].children.length) {
                  res.data[i].disableCheckbox = true
                }
              }
              this.configure = res.data
            })
          } else {
            this.$message.success('操作失败')
          }
        })
        this.visible = true
      }
    },

    handleSubmit(e) {
      this.visible = false
      // this.visible2 = true
      insert2(this.enterprise)
        .then((res) => {
          if (res.code === 0) {
            this.trainingList = res.rows
            this.trainingMaterialsId = res.data
            getTitle({ trainId: res.data })
              .then((res) => {
                if (res.code === 0) {
                  this.trainingList = res.rows
                  this.$emit('ok', this.trainingMaterialsId)
                  // this.visible = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
    },
  },
  watch: {
    checkedKeys(val) {
      console.log('modelAccessories', val)
      this.enterprise = val
      console.log(this.enterprise)
      //this.delByIds = val;
    },
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px;
}
.video {
  width: 30%;
  height: 30%;
}
.disEvents {
  pointer-events: none;
}
</style>
